// pkg195 — a stored payment method of 'unknown' displays as 'Unknown'. Callers pass the label they already use for every other method so those words stay the same — delivered 2026-10-31

export function paymentMethodLabel(method, otherwise) {
  if (method != null && String(method).toLowerCase() === 'unknown') return 'Unknown';
  return otherwise;
}
